
let timeout = null;
const REGEX_RESERVED_CHARACTERS = /[/\-\\^$*+?.()|[\]{}]/g;

export function logMetadata(linkObj, searchString, count) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
        const role = EG.user && EG.user.roleType || "";
        uitk.logger.info(`UserRole: ${role}, SearchBoxInput: ${searchString}, NumResults: ${count}`);
        const searchResultsTag = `HelpCenter.SearchBar.Filled`;
        uitk.analytics.set("prop16", searchResultsTag);
        uitk.analytics.set("eVar28", searchResultsTag);
        uitk.analytics.set("prop1", count);
        uitk.analytics.set("eVar45", searchString);
        uitk.analytics.track('o',{linkObj, linkId: searchResultsTag, linkName:searchResultsTag, linkTrackVars:`prop1,prop16,eVar28,eVar45`});
    }, EG.analytics.configs['help-center.search.log_interval'].value);
}

export const searchFaq = {   
    search: function(term, articles) {
        return articles.filter((article) => {
            try {
                const articleBodyWithoutHtmlTags = new DOMParser().parseFromString(article.body, 'text/html').body.textContent;
                const allArticleText = article.title.toLowerCase() + ' ' + articleBodyWithoutHtmlTags.toLowerCase();
                return allArticleText.includes(term.toLowerCase())
            } catch (e) {
                uitk.logger.error(`Failed to search for "${term}", in article ${article.id}`, e);
                return false;
            }
        });
    },
    
    highlightArticles(articles, highlight) {
        return articles.map(article => {
            return {
                ...article,
                title: this.highlight(article.title, highlight),
                body: this.highlight(article.body, highlight),
            }
        });
    },

    highlight(text, highlight) {
        try {
            const highlightWithEscapedSpecialChars = highlight.replace(REGEX_RESERVED_CHARACTERS, '\\$&');
            return text.replaceAll(new RegExp(highlightWithEscapedSpecialChars + '(?!([^<]+)?>)', 'ig'),
                (str) => `<span class="text-highlight">${str}</span>`
            );
        } catch (e) {
            uitk.logger.error(`Failed to highlight articles with term "${highlight}"`, e);
            return text;
        }
    },
};